import React, { useEffect, useState } from 'react'
import './styles.scss'
import Text from '../text/Text'
import Heading from '../heading/Heading'
import Checkbox from '../form/checkbox/Checkbox'
import { useSelector, useDispatch } from 'react-redux'
import Input from '../form/inputs/Input'
import InputPesel from '../form/inputs/InputPesel'


const Authorizations = (props) => {
    let [ updateArray, setUpdateArray ] = useState(0);
    let [ checkAllCheckbox, setCheckAllCheckbox ] = useState(false);
    let [ checkAllSecondCheckbox, setCheckAllSecondCheckbox ] = useState(false);
    let [ applicantStatus, setApplicantStatus ] = useState(false);
    let [ applicantPerson, setApplicantPerson ] = useState(false);

    const dispatch          = useDispatch()
    let authCheckOne        = useSelector(state => state.authCheckOne)
    let authCheckTwo        = useSelector(state => state.authCheckTwo)
    let authCheckThree      = useSelector(state => state.authCheckThree)
    let authCheckFour       = useSelector(state => state.authCheckFour)
    let authCheckFive       = useSelector(state => state.authCheckFive)
    let authCheckSix        = useSelector(state => state.authCheckSix)
    let authCheckSeven      = useSelector(state => state.authCheckSeven)
    let authCheckEight      = useSelector(state => state.authCheckEight)
    let authorizedPersons   = useSelector(state => state.authorizedPersons)
    let registryType        = useSelector(state => state.registryType)

    // useEffect(() => {
    //     if ( authCheckThree ) {
        
    //         checkAll();
    //     }
    //     if ( !authCheckThree && authCheckFour && authCheckFive && authCheckSix ) {
    //         uncheckAll();
    //     }
    // }, [authCheckThree])

    // useEffect(() => {
    //     if ( !authCheckFour || !authCheckFive || !authCheckSix || !authCheckSix ) {
    //         dispatch({ type: 'AUTH_CHECK_THREE_CHANGE', value: false })
    //     }
    // }, [authCheckFour, authCheckFive, authCheckSix, authCheckSix, ])

    let checkAll = () => {
        dispatch({ type: 'AUTH_CHECK_THREE_CHANGE', value: true })
        dispatch({ type: 'AUTH_CHECK_FOUR_CHANGE', value: true })
    }

    let uncheckAll = () => {
        dispatch({ type: 'AUTH_CHECK_THREE_CHANGE', value: false })
        dispatch({ type: 'AUTH_CHECK_FOUR_CHANGE', value: false })
    }

    let checkAllSecond = () => {
        dispatch({ type: 'AUTH_CHECK_FIVE_CHANGE', value: true })
        dispatch({ type: 'AUTH_CHECK_SIX_CHANGE', value: true })
    }

    let uncheckAllSecond = () => {
        dispatch({ type: 'AUTH_CHECK_FIVE_CHANGE', value: false })
        dispatch({ type: 'AUTH_CHECK_SIX_CHANGE', value: false })
    }

    let updateValue =  async( val, index, property ) => {
        let copyArray = authorizedPersons;

        copyArray[index][property] = val;
        
        dispatch({ type: 'AUTHORIZED_PERSONS_CHANGE', value: copyArray })
        await setUpdateArray(++updateArray);
    }

    return (
        <div className="authorizations">
            < Heading title="OŚWIADCZENIA, ZGODY I UPOWAŻNIENIA WNIOSKODAWCY" medium />
            < Heading title="Oświadczenia " smallBigger />
            < Checkbox required={ true } 
                       id="auth-check-one"
                       setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_ONE_CHANGE', value: val })}
                       val={ authCheckOne }
                       forceValidate={ props.forceValidate }
                       showMore={applicantStatus}
                       setShowMore={(status) => setApplicantStatus(status) }
                       onclickItemID={"more-or-less-first"}
                       text={applicantStatus ? "Oświadczenia Wnioskodawcy niezbędne do rozpatrzenia wniosku.<strong style='display: block;margin: 5px 0'>WNIOSKODAWCA OŚWIADCZA, że:</strong>a) Jest upoważniony do działania w imieniu Wnioskodawcy w zakresie oświadczeń woli zawartych w niniejszym wniosku; b) Nie znajduje się w trakcie zmian organizacyjnych wymagających ich ujawnienia we właściwym rejestrze; c) Nie toczy się przeciwko niemu żadne postępowanie upadłościowe, likwidacyjne ani układowe oraz że nie znajduje się w procesie restrukturyzacji i nie jest przeciwko niemu prowadzona egzekucja skarbowa lub komornicza; d) Został poinformowany, że Administratorem danych jest GRENKELEASING Sp. z o.o., a wszystkie informacje na temat przetwarzania jego danych osobowych opisane są w Informacji o danych osobowych, stanowiącej załącznik do Wniosku; e) Wszystkie osoby fizyczne, których dane zostały zawarte we wniosku, zapoznały się z Informacją o danych osobowych, stanowiącą załącznik do wniosku; f) W przypadku udzielenia zgody na przetwarzanie danych osobowych w celach handlowo – marketingowych (numeru telefonu i/lub adresu e-mail) zgody te są rozumiane na podstawie art. 10 ust. 1 ustawy z dnia 18 lipca 2002 roku o świadczeniu usług drogą elektroniczną oraz art. 172 prawa telekomunikacyjnego. <p class='more-or-less' id='more-or-less-first'>Zwiń.</p> " : " Oświadczenia Wnioskodawcy niezbędne do rozpatrzenia wniosku. <p class='more-or-less' id='more-or-less-first'>Zobacz pełną treść.</p>"} />
            < Checkbox required={ true } 
                       id="auth-check-two"
                       setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_TWO_CHANGE', value: val })}
                       val={ authCheckTwo }
                       forceValidate={ props.forceValidate }
                       text=" Oświadczam, że wszystkie informacje podane przeze mnie w niniejszym wniosku i załączonych do niego dokumentach są  kompletne i zgodne z prawdą i jestem świadomy /świadoma odpowiedzialności karnej, wynikającej ze składania nieprawdziwych informacji. " />
            < Heading title="Przetwarzanie danych" smallBigger otherMargins />
            < Text smallMargin text="Administratorem danych jest GRENKELEASING Sp. z o.o. (dalej: GRENKE). Więcej informacji na temat uprawnień i przetwarzania Twoich danych osobowych dostępne jest w <a href='https://newonline.leasingoptymalny.pl/od/' target='_blank'>Informacji o danych osobowych.</a>"/>
            < Text smallMargin text="Przetwarzanie danych osobowych w celu marketingu bezpośredniego produktów i usług GRENKE" />
            <div className="checks">
                < Checkbox required={ false } 
                    id="select"
                    setFunction={ (val) => { val ? checkAll() : uncheckAll(); setCheckAllCheckbox(val)}}
                    val={ checkAllCheckbox }
                    text="ZAZNACZ WYSZYSTKIE (oznacza - zgadzam się na wszystkie poniższe) ." />
                < Checkbox required={ false } 
                    id="auth-check-three"
                    setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_THREE_CHANGE', value: val })}
                    val={ authCheckThree }
                    forceValidate={ props.forceValidate }
                    text=" Wyrażam zgodę na otrzymywanie od GRENKE treści handlowo - marketingowych drogą elektroniczną." />
                < Checkbox required={ false } 
                    id="auth-check-four"
                    setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_FOUR_CHANGE', value: val })}
                    val={ authCheckFour }
                    forceValidate={ props.forceValidate }
                    text="Wyrażam zgodę na otrzymywanie od GRENKE treści handlowo - marketingowych drogą telefoniczną." />
                {/* <Text class="small-font margin-top" text="*Pola wymagane." /> */}
            </div>
            < Text smallMargin text="Przetwarzania danych osobowych w celu marketingu bezpośredniego produktów i usług GC Faktoring Sp. z o. o. NIP 7773270550 z Grupy GRENKE" />
            <div className="checks">
                < Checkbox required={ false } 
                    id="select-second"
                    setFunction={ (val) => { val ? checkAllSecond() : uncheckAllSecond(); setCheckAllSecondCheckbox(val)}}
                    val={ checkAllSecondCheckbox }
                    text="ZAZNACZ WYSZYSTKIE (oznacza - zgadzam się na wszystkie poniższe) ." />
                < Checkbox required={ false } 
                    id="auth-check-five"
                    setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_FIVE_CHANGE', value: val })}
                    val={ authCheckFive }
                    forceValidate={ props.forceValidate }
                    text="Wyrażam zgodę na otrzymywanie od <span class='cloud break'>GC Faktoring</span> treści handlowych i marketingowych drogą elektroniczną." />
                < Checkbox required={ false } 
                    id="auth-check-six"
                    setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_SIX_CHANGE', value: val })}
                    val={ authCheckSix }
                    forceValidate={ props.forceValidate }
                    text="Wyrażam zgodę na otrzymywanie od <span class='cloud break'>GC Faktoring</span> treści handlowych i marketingowych drogą telefoniczną." />
                {/* <Text class="small-font margin-top" text="*Pola wymagane." /> */}
            </div>
            { registryType === 'CEIDG' &&
                <>
                    <div style={{ marginTop: '30px' }} />
                    < Heading title="Weryfikacja osoby fizycznej" smallBigger />
                    < Text 
                        smallMargin 
                        text={applicantPerson ? "Udzielam pełnomocnictwa do sprawdzenia w BIG InfoMonitor, KRD, ERIF moich danych gospodarczych. Dotyczy jednoosobowej działalności gospodarczej oraz wspólnika spółki cywilnej.</br><p style='font-size: 16px'>Na podstawie art. 24 ust. 1 Ustawy z dnia 9 kwietnia 2010 r. o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych oraz na podstawie art. 105 ust. 4a i 4a' Ustawy z dnia 29 sierpnia 1997 roku Prawo bankowe w związku z art. 13 Ustawy z dnia 9 kwietnia 2010 r. o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych, niniejszym udzielam GRENKELEASING Sp. z o.o. z siedzibą w Poznaniu bezterminowego pełnomocnictwa do składania w moim imieniu za pośrednictwem: BIG InfoMonitor S.A. z siedzibą w Warszawie – w Biurze Informacji Kredytowej S.A. oraz Związku Banków Polskich, Krajowego Rejestru Długów BIG S.A. z siedzibą we Wrocławiu, a także Rejestru Dłużników ERIF BIG S.A. z siedzibą w Warszawie upoważnień do udostępniania danych gospodarczych przetwarzanych przez te instytucje, w zakresie niezbędnym do dokonania oceny wiarygodności płatniczej i oceny ryzyka kredytowego, w tym oceny punktowej (scoring), celem ujawnienia ich GRENKELEASING Sp. z o.o. przez ww. podmioty. Niniejsze pełnomocnictwo obejmuje również pozyskanie z wyżej wymienionych instytucji dotyczących mnie informacji gospodarczych. Informacje na temat przetwarzania i uprawnień dotyczących danych osobowych dostępne są w Informacji o danych osobowych.</p>" : "Udzielam pełnomocnictwa do sprawdzenia w BIG InfoMonitor, KRD, ERIF moich danych gospodarczych. Dotyczy jednoosobowej działalności gospodarczej oraz wspólnika spółki cywilnej. <p class='more-or-less' id='more-or-less-second'>Zobacz pełną treść.</p>"} 
                        showMore={!applicantPerson}
                        setShowMore={(status) => setApplicantPerson(status) } 
                        onclickItemID={"more-or-less-second"} />
                    <div className="inputs inputs-person">
                        { updateArray >= 0 && authorizedPersons && authorizedPersons.map( ( item, index ) => (
                            <>
                            { index === 0 && 
                                <>
                                    <div className="col">
                                        < Input
                                            id={"step-five-name" + index}
                                            name={"name"}
                                            required={ true }
                                            setFunction={ val => { updateValue(val, index, 'name'); } }
                                            type="text"
                                            placehold={ "Imię" }
                                            val={ item.name }
                                            size="xxl" 
                                            regExp={ null }
                                            minChar={ 1 } 
                                            forceValidate={ props.forceValidate }
                                            forceValidateItems={ props.forceValidateItems } />
                                    </div>
                                    <div className="col">
                                        < Input
                                            id={"step-five-surname" + index}
                                            name={"Surname"}
                                            required={ true }
                                            setFunction={ val => { updateValue(val, index, 'surname'); } }
                                            type="text"
                                            placehold={ "Nazwisko" }
                                            val={ item.surname }
                                            size="xxl" 
                                            regExp={ null }
                                            minChar={ 1 } 
                                            forceValidate={ props.forceValidate }
                                            forceValidateItems={ props.forceValidateItems } />
                                    </div>
                                    <div className="col">
                                        < Input
                                            id={"step-five-address" + index}
                                            name={"address"}
                                            required={ false }
                                            setFunction={ val => { updateValue(val, index, 'address'); } }
                                            type="text"
                                            placehold={ "Adres zamieszkania" }
                                            val={ item.address }
                                            size="xxl" 
                                            regExp={ null }
                                            minChar={ 0 } 
                                            forceValidate={ props.forceValidate }
                                            forceValidateItems={ props.forceValidateItems } />
                                    </div>
                                    <div className="col">
                                        < InputPesel
                                            id={"step-five-pesel" + index}
                                            name={"pesel"}
                                            required={ true }
                                            setFunction={ val => { updateValue(val, index, 'pesel'); } }
                                            type="text"
                                            placehold={ "PESEL" }
                                            val={ item.pesel }
                                            size="xxl" 
                                            regExp={/^[0-9]{11}$/}
                                            allowChars={/^[0-9]{0,11}$/}
                                            minChar={ 1 } 
                                            forceValidate={ props.forceValidate }
                                            forceValidateItems={ props.forceValidateItems } />
                                    </div>
                                    <div className="col">
                                        < Input
                                            id={"step-five-id" + index}
                                            name={"id"}
                                            required={ true }
                                            setFunction={ val => { updateValue(val, index, 'id'); } }
                                            type="text"
                                            placehold={ "Seria i numer dowodu osobistego" }
                                            val={ item.id }
                                            size="xxl" 
                                            regExp={ null }
                                            minChar={ 0 } 
                                            forceValidate={ props.forceValidate }
                                            forceValidateItems={ props.forceValidateItems } />
                                    </div>
                                </>
                            }
                            </>
                            
                        )) } 
                    </div>
                </>
            }
        </div>
       
    )
}

export default Authorizations;



// import React, { useEffect, useState } from 'react'
// import './styles.scss'
// import Text from '../text/Text'
// import Heading from '../heading/Heading'
// import Checkbox from '../form/checkbox/Checkbox'
// import { useSelector, useDispatch } from 'react-redux'
// import Input from '../form/inputs/Input'
// import InputPesel from '../form/inputs/InputPesel'


// const Authorizations = (props) => {
//     let [ updateArray, setUpdateArray ] = useState(0);
//     let [ applicantStatus, setApplicantStatus ] = useState(false);
//     let [ applicantPerson, setApplicantPerson ] = useState(false);

//     const dispatch          = useDispatch()
//     let authCheckOne        = useSelector(state => state.authCheckOne)
//     let authCheckTwo        = useSelector(state => state.authCheckTwo)
//     let authCheckThree      = useSelector(state => state.authCheckThree)
//     let authCheckFour       = useSelector(state => state.authCheckFour)
//     let authCheckFive       = useSelector(state => state.authCheckFive)
//     let authCheckSix        = useSelector(state => state.authCheckSix)
//     let authCheckSeven      = useSelector(state => state.authCheckSeven)
//     let authCheckEight      = useSelector(state => state.authCheckEight)
//     let authorizedPersons   = useSelector(state => state.authorizedPersons)
//     let registryType        = useSelector(state => state.registryType)

//     // useEffect(() => {
//     //     if ( authCheckThree ) {
        
//     //         checkAll();
//     //     }
//     //     if ( !authCheckThree && authCheckFour && authCheckFive && authCheckSix ) {
//     //         uncheckAll();
//     //     }
//     // }, [authCheckThree])

//     // useEffect(() => {
//     //     if ( !authCheckFour || !authCheckFive || !authCheckSix || !authCheckSix ) {
//     //         dispatch({ type: 'AUTH_CHECK_THREE_CHANGE', value: false })
//     //     }
//     // }, [authCheckFour, authCheckFive, authCheckSix, authCheckSix, ])

//     let checkAll = () => {
//         dispatch({ type: 'AUTH_CHECK_FOUR_CHANGE', value: true })
//         dispatch({ type: 'AUTH_CHECK_FIVE_CHANGE', value: true })
//         dispatch({ type: 'AUTH_CHECK_SIX_CHANGE', value: true })
//         // dispatch({ type: 'AUTH_CHECK_SEVEN_CHANGE', value: true })
//         // dispatch({ type: 'AUTH_CHECK_EIGHT_CHANGE', value: true })
//     }

//     let uncheckAll = () => {
//         dispatch({ type: 'AUTH_CHECK_FOUR_CHANGE', value: false })
//         dispatch({ type: 'AUTH_CHECK_FIVE_CHANGE', value: false })
//         dispatch({ type: 'AUTH_CHECK_SIX_CHANGE', value: false })
//         // dispatch({ type: 'AUTH_CHECK_SEVEN_CHANGE', value: false })
//         // dispatch({ type: 'AUTH_CHECK_EIGHT_CHANGE', value: false })
//     }

//     let updateValue =  async( val, index, property ) => {
//         let copyArray = authorizedPersons;

//         copyArray[index][property] = val;
        
//         dispatch({ type: 'AUTHORIZED_PERSONS_CHANGE', value: copyArray })
//         await setUpdateArray(++updateArray);
//     }

//     return (
//         <div className="authorizations">
//             < Heading title="Upoważnienia i zgody" medium />
//             < Checkbox required={ true } 
//                        id="auth-check-one"
//                        setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_ONE_CHANGE', value: val })}
//                        val={ authCheckOne }
//                        forceValidate={ props.forceValidate }
//                        showMore={!applicantStatus}
//                        setShowMore={(status) => setApplicantStatus(status) }
//                        onclickItemID={"more-or-less-first"}
//                        text={applicantStatus ? " Udzielam pełnomocnictwa do sprawdzenia w BIG InfoMonitor, KRD, ERIF danych gospodarczych wnioskodawcy. </br>Na podstawie art. 105 ust. 4a i 4a' Ustawy Prawo bankowe w związku z art. 13 Ustawy z dnia 9 kwietnia 2010 r. o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych, niniejszym udzielam GRENKELEASING Sp. z o.o. z siedzibą w Poznaniu bezterminowego pełnomocnictwa do składania w imieniu Wnioskodawcy, za pośrednictwem: BIG InfoMonitor S.A. z siedzibą w Warszawie – w Biurze Informacji Kredytowej S.A. oraz w Związku Banków Polskich, Krajowego Rejestru Długów BIG S.A. z siedzibą we Wrocławiu, a także Rejestru Dłużników ERIF BIG S.A. z siedzibą w Warszawie upoważnień do udostępniania danych gospodarczych przetwarzanych przez te instytucje, w zakresie niezbędnym do dokonania oceny wiarygodności płatniczej i oceny ryzyka kredytowego, celem ujawnienia ich GRENKELEASING Sp. z o.o. przez ww. podmioty. Informacje na temat przetwarzania i uprawnień dotyczących danych osobowych dostępne są w <a href='https://newonline.leasingoptymalny.pl/od/' target='_blank'> Informacji o danych osobowych.</a>" : " Udzielam pełnomocnictwa do sprawdzenia w BIG InfoMonitor, KRD, ERIF danych gospodarczych wnioskodawcy. <p class='more-or-less' id='more-or-less-first'>Zobacz pełną treść.</p>"} />
//             < Checkbox required={ true } 
//                        id="auth-check-two"
//                        setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_TWO_CHANGE', value: val })}
//                        val={ authCheckTwo }
//                        forceValidate={ props.forceValidate }
//                        text=" Oświadczam, że wszystkie informacje podane przeze mnie / nas w niniejszym wniosku i załączonych do niego dokumentach są zgodne z prawdą i jestem świadomy/świadoma odpowiedzialności karnej, wynikającej ze składania nieprawdziwych informacji. " />
            
//             { registryType === 'CEIDG' &&
//                 <>
//                     <div style={{ marginTop: '30px' }} />
//                     < Heading title="Weryfikacja osoby fizycznej" smallBigger />
//                     < Text 
//                         smallMargin 
//                         text={applicantPerson ? "Udzielam pełnomocnictwa do sprawdzenia w BIG InfoMonitor, KRD, ERIF moich danych gospodarczych. Dotyczy jednoosobowej działalności gospodarczej oraz wspólnika spółki cywilnej.</br><p style='font-size: 16px'>Na podstawie art. 24 ust. 1 Ustawy z dnia 9 kwietnia 2010 r. o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych oraz na podstawie art. 105 ust. 4a i 4a' Ustawy z dnia 29 sierpnia 1997 roku Prawo bankowe w związku z art. 13 Ustawy z dnia 9 kwietnia 2010 r. o udostępnianiu informacji gospodarczych i wymianie danych gospodarczych, niniejszym udzielam GRENKELEASING Sp. z o.o. z siedzibą w Poznaniu bezterminowego pełnomocnictwa do składania w moim imieniu za pośrednictwem: BIG InfoMonitor S.A. z siedzibą w Warszawie – w Biurze Informacji Kredytowej S.A. oraz Związku Banków Polskich, Krajowego Rejestru Długów BIG S.A. z siedzibą we Wrocławiu, a także Rejestru Dłużników ERIF BIG S.A. z siedzibą w Warszawie upoważnień do udostępniania danych gospodarczych przetwarzanych przez te instytucje, w zakresie niezbędnym do dokonania oceny wiarygodności płatniczej i oceny ryzyka kredytowego, w tym oceny punktowej (scoring), celem ujawnienia ich GRENKELEASING Sp. z o.o. przez ww. podmioty. Niniejsze pełnomocnictwo obejmuje również pozyskanie z wyżej wymienionych instytucji dotyczących mnie informacji gospodarczych. Informacje na temat przetwarzania i uprawnień dotyczących danych osobowych dostępne są w Informacji o danych osobowych.</p>" : "Udzielam pełnomocnictwa do sprawdzenia w BIG InfoMonitor, KRD, ERIF moich danych gospodarczych. Dotyczy jednoosobowej działalności gospodarczej oraz wspólnika spółki cywilnej. <p class='more-or-less' id='more-or-less-second'>Zobacz pełną treść.</p>"} 
//                         showMore={!applicantPerson}
//                         setShowMore={(status) => setApplicantPerson(status) } 
//                         onclickItemID={"more-or-less-second"} />
//                     <div className="inputs inputs-person">
//                         { updateArray >= 0 && authorizedPersons && authorizedPersons.map( ( item, index ) => (
//                             <>
//                             { index === 0 && 
//                                 <>
//                                     <div className="col">
//                                         < Input
//                                             id={"step-five-name" + index}
//                                             name={"name"}
//                                             required={ true }
//                                             setFunction={ val => { updateValue(val, index, 'name'); } }
//                                             type="text"
//                                             placehold={ "Imię" }
//                                             val={ item.name }
//                                             size="xxl" 
//                                             regExp={ null }
//                                             minChar={ 1 } 
//                                             forceValidate={ props.forceValidate }
//                                             forceValidateItems={ props.forceValidateItems } />
//                                     </div>
//                                     <div className="col">
//                                         < Input
//                                             id={"step-five-surname" + index}
//                                             name={"Surname"}
//                                             required={ true }
//                                             setFunction={ val => { updateValue(val, index, 'surname'); } }
//                                             type="text"
//                                             placehold={ "Nazwisko" }
//                                             val={ item.surname }
//                                             size="xxl" 
//                                             regExp={ null }
//                                             minChar={ 1 } 
//                                             forceValidate={ props.forceValidate }
//                                             forceValidateItems={ props.forceValidateItems } />
//                                     </div>
//                                     <div className="col">
//                                         < Input
//                                             id={"step-five-address" + index}
//                                             name={"address"}
//                                             required={ false }
//                                             setFunction={ val => { updateValue(val, index, 'address'); } }
//                                             type="text"
//                                             placehold={ "Adres zamieszkania" }
//                                             val={ item.address }
//                                             size="xxl" 
//                                             regExp={ null }
//                                             minChar={ 0 } 
//                                             forceValidate={ props.forceValidate }
//                                             forceValidateItems={ props.forceValidateItems } />
//                                     </div>
//                                     <div className="col">
//                                         < InputPesel
//                                             id={"step-five-pesel" + index}
//                                             name={"pesel"}
//                                             required={ true }
//                                             setFunction={ val => { updateValue(val, index, 'pesel'); } }
//                                             type="text"
//                                             placehold={ "PESEL" }
//                                             val={ item.pesel }
//                                             size="xxl" 
//                                             regExp={/^[0-9]{11}$/}
//                                             allowChars={/^[0-9]{0,11}$/}
//                                             minChar={ 1 } 
//                                             forceValidate={ props.forceValidate }
//                                             forceValidateItems={ props.forceValidateItems } />
//                                     </div>
//                                     <div className="col">
//                                         < Input
//                                             id={"step-five-id" + index}
//                                             name={"id"}
//                                             required={ true }
//                                             setFunction={ val => { updateValue(val, index, 'id'); } }
//                                             type="text"
//                                             placehold={ "Seria i numer dowodu osobistego" }
//                                             val={ item.id }
//                                             size="xxl" 
//                                             regExp={ null }
//                                             minChar={ 0 } 
//                                             forceValidate={ props.forceValidate }
//                                             forceValidateItems={ props.forceValidateItems } />
//                                     </div>
//                                 </>
//                             }
//                             </>
                            
//                         )) } 
//                     </div>
//                 </>
//             }
//             {registryType !== 'CEIDG' &&
//                 <div style={{ marginBottom: '30px'}} />
//             }
//             < Heading title="Przetwarzanie danych" smallBigger otherMargins />
//             < Text smallMargin text="Administratorem danych jest GRENKELEASING Sp. z o.o. (dalej: GRENKE). Więcej informacji na temat uprawnień i przetwarzania Twoich danych osobowych dostępne jest w <a href='https://newonline.leasingoptymalny.pl/od/' target='_blank'>Informacji o danych osobowych.</a>"/>
//             <div className="checks">

//                 < Checkbox required={ false } 
//                        id="auth-check-five"
//                        setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_FIVE_CHANGE', value: val })}
//                        val={ authCheckFive }
//                        forceValidate={ props.forceValidate }
//                        text="Wyrażam zgodę na otrzymywanie od GRENKE treści marketingowych oraz handlowych na temat własnych produktów i usług GRENKE drogą elektroniczną oraz drogą telefoniczną." />
//                 < Checkbox required={ false } 
//                        id="auth-check-four"
//                        setFunction={ (val) => dispatch({ type: 'AUTH_CHECK_FOUR_CHANGE', value: val })}
//                        val={ authCheckFour }
//                        forceValidate={ props.forceValidate }
//                        text="Wyrażam zgodę na udostępnienie moich danych spółce <span class='cloud break'>GC Faktoring</span> w celach marketingowych oraz handlowwych na temat produktów i usług <span class='cloud break'>GC Faktoring</span> drogą elektroniczną oraz drogą telefoniczną." />
//                 <Text class="small-font margin-top" text="*Pola wymagane." />
                
//             </div>
//         </div>
       
//     )
// }

// export default Authorizations;